import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "fw-bold mb-1" };
const _hoisted_2 = { class: "mb-3 text-secondary" };
const _hoisted_3 = {
    key: 0,
    class: "text-secondary mt-2 mb-0"
};
const _hoisted_4 = {
    key: 1,
    class: "alert alert-danger mb-3",
    role: "alert"
};
const _hoisted_5 = { class: "tab-content rounded bg-white p-3 mb-4" };
const _hoisted_6 = {
    class: "tab-pane fade show active",
    id: "details-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "details-tab",
    tabindex: "0"
};
const _hoisted_7 = { class: "row mb-4" };
const _hoisted_8 = { class: "col-lg-6 col-12" };
const _hoisted_9 = { class: "form-check mb-3" };
const _hoisted_10 = { class: "form-floating mb-3" };
const _hoisted_11 = { class: "form-floating mb-3" };
const _hoisted_12 = { class: "form-floating mb-3" };
const _hoisted_13 = { class: "input-group mb-3" };
const _hoisted_14 = { class: "form-floating" };
const _hoisted_15 = { class: "form-floating mb-3" };
const _hoisted_16 = { class: "mb-3" };
const _hoisted_17 = { class: "mb-3" };
const _hoisted_18 = { class: "col-12 col-lg-6" };
const _hoisted_19 = { class: "mb-4" };
const _hoisted_20 = { class: "mb-3" };
const _hoisted_21 = { class: "row mt-4" };
const _hoisted_22 = { class: "col-12 col-lg-6" };
const _hoisted_23 = {
    class: "tab-pane fade",
    id: "product-images-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "product-images-tab",
    tabindex: "0"
};
import { FilterMatchMode } from '@primevue/core/api';
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, router, useForm } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { MultiSelect, useConfirm } from 'primevue';
import TinyEditor from '@/Components/TinyEditor.vue';
import axios from 'axios';
import ProductImages from '@/Tenant/Components/ProductImages.vue';
import ProductPriceOption from '@/Tenant/Components/ProductPriceOption.vue';
import ProductPriceAddition from '@/Tenant/Components/ProductPriceAddition.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        package: Object,
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const confirm = useConfirm();
        const editPackageForm = useForm({
            artNo: props.package?.artNo ?? '',
            name: props.package?.name ?? '',
            nameEn: props.package?.nameEn ?? '',
            description: props.package?.description ?? '',
            descriptionEn: props.package?.descriptionEn ?? '',
            weight: props.package?.weight ?? 0,
            maxProductsAmount: props.package?.maxProductsAmount ?? 0,
            active: props.package?.active ?? false
        });
        const productCategories = ref([]);
        const selectedProductCategories = ref([]);
        onMounted(() => {
            loadAvailableProductCategories();
            selectedProductCategories.value = props.package?.productCategories.map((category) => {
                return category.uuid;
            }) ?? [];
        });
        function loadAvailableProductCategories() {
            axios.post(route('admin.productCategories.load')).then((response) => {
                productCategories.value = response.data;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function updatePackage() {
            if (props.package == null) {
                return;
            }
            editPackageForm.transform((data) => ({
                art_no: data.artNo,
                name: data.name,
                name_en: data.nameEn,
                description: data.description,
                description_en: data.descriptionEn,
                weight: data.weight,
                max_products_amount: data.maxProductsAmount,
                active: data.active
            }))
                .submit('put', route('admin.packages.update', props.package.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function removePackage() {
            confirm.require({
                message: 'Soll die Verpackung wirklich gelöscht werden?',
                header: 'Verpackung löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if (props.package == null) {
                        return;
                    }
                    router.delete(route('admin.packages.destroy', props.package.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function updateProductCategories() {
            if (props.package == null) {
                return;
            }
            if (selectedProductCategories.value.length === 0) {
                showErrorMessage('Bitte wählen Sie mindestens eine Produktkategorie aus.');
                return;
            }
            router.post(route('admin.packages.productCategories.update', props.package.uuid), {
                'productCategoryUuids': selectedProductCategories.value
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Verpackung" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_1, "Verpackung: " + _toDisplayString(props.package.name), 1),
                        _createElementVNode("p", _hoisted_2, "Letzte Änderung: " + _toDisplayString(_unref(formatDate)(props.package.updatedAt, true)), 1),
                        (props.package.supplier)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Lieferant: " + _toDisplayString(props.package.supplier.name), 1))
                            : _createCommentVNode("", true),
                        (props.package.priceBundle && !props.package.priceBundle.active)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Produkt ist mit einem inaktiven Preis-Bundle verknüpft. Produkt kann somit nicht eingesetzt werden."))
                            : _createCommentVNode("", true),
                        _cache[24] || (_cache[24] = _createElementVNode("ul", {
                            class: "nav nav-underline mb-3",
                            role: "tablist"
                        }, [
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link active",
                                    id: "details-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#details-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "details-tab-pane",
                                    "aria-selected": "true"
                                }, "Details")
                            ]),
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link",
                                    id: "product-images-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#product-images-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "product-images-tab-pane",
                                    "aria-selected": "false"
                                }, "Produkt-Bilder")
                            ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(updatePackage, ["prevent"])
                                        }, [
                                            _createElementVNode("div", _hoisted_9, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: "active",
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(editPackageForm).active) = $event))
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(editPackageForm).active]
                                                ]),
                                                _cache[9] || (_cache[9] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "active"
                                                }, "Aktiv (Verpackung kann genutzt werden)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_10, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "artNo",
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(editPackageForm).artNo) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(editPackageForm).artNo]
                                                ]),
                                                _cache[10] || (_cache[10] = _createElementVNode("label", { for: "artNo" }, "Artnr.", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_11, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "name",
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(editPackageForm).name) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(editPackageForm).name]
                                                ]),
                                                _cache[11] || (_cache[11] = _createElementVNode("label", { for: "name" }, "Name", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_12, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "nameEn",
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(editPackageForm).nameEn) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(editPackageForm).nameEn]
                                                ]),
                                                _cache[12] || (_cache[12] = _createElementVNode("label", { for: "nameEn" }, "Name (en)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_13, [
                                                _createElementVNode("div", _hoisted_14, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(editPackageForm).weight) = $event)),
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editPackageForm).weight]
                                                    ]),
                                                    _cache[13] || (_cache[13] = _createElementVNode("label", { for: "weight" }, "Gewicht", -1))
                                                ]),
                                                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "input-group-text" }, "g", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_15, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "maxProductsAmount",
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(editPackageForm).maxProductsAmount) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(editPackageForm).maxProductsAmount]
                                                ]),
                                                _cache[15] || (_cache[15] = _createElementVNode("label", { for: "maxProductsAmount" }, "Max. Produkt-Anzahl pro Verpackung", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_16, [
                                                _cache[16] || (_cache[16] = _createElementVNode("label", {
                                                    for: "description",
                                                    class: "mb-2"
                                                }, "Beschreibung", -1)),
                                                _createVNode(TinyEditor, {
                                                    id: "description",
                                                    modelValue: _unref(editPackageForm).description,
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(editPackageForm).description) = $event)),
                                                    height: 300
                                                }, null, 8, ["modelValue"])
                                            ]),
                                            _createElementVNode("div", _hoisted_17, [
                                                _cache[17] || (_cache[17] = _createElementVNode("label", {
                                                    for: "descriptionEn",
                                                    class: "mb-2"
                                                }, "Beschreibung (en)", -1)),
                                                _createVNode(TinyEditor, {
                                                    id: "descriptionEn",
                                                    modelValue: _unref(editPackageForm).descriptionEn,
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(editPackageForm).descriptionEn) = $event)),
                                                    height: 300
                                                }, null, 8, ["modelValue"])
                                            ]),
                                            _cache[18] || (_cache[18] = _createElementVNode("button", {
                                                type: "submit",
                                                class: "btn btn-success d-inline-flex align-items-center"
                                            }, [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-check2",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                ]),
                                                _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                            ], -1))
                                        ], 32),
                                        (props.package.canRemove)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "btn btn-danger d-inline-flex align-items-center mt-4",
                                                onClick: removePackage
                                            }, [...(_cache[19] || (_cache[19] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-x-circle",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                        _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                    ], -1),
                                                    _createElementVNode("span", { class: "ms-2" }, "Verpackung löschen", -1)
                                                ]))]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("div", _hoisted_19, [
                                            _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "fw-bold text-primary mb-3" }, "Produktkategorien", -1)),
                                            _createElementVNode("div", _hoisted_20, [
                                                _createVNode(_unref(MultiSelect), {
                                                    class: "w-100",
                                                    modelValue: selectedProductCategories.value,
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((selectedProductCategories).value = $event)),
                                                    options: productCategories.value,
                                                    filter: "",
                                                    optionLabel: "name",
                                                    optionValue: "uuid",
                                                    placeholder: "Produktkategorien wählen"
                                                }, null, 8, ["modelValue", "options"])
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-success d-inline-flex align-items-center",
                                                onClick: updateProductCategories
                                            }, [...(_cache[20] || (_cache[20] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-check2",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                    ], -1),
                                                    _createElementVNode("span", { class: "ms-2" }, "Speichern", -1)
                                                ]))])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", null, [
                                    _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "fw-bold bg-primary text-white mb-4 px-3 py-2" }, "Preise", -1)),
                                    _createVNode(ProductPriceOption, {
                                        package: props.package,
                                        priceBundleUuid: props.package.priceBundleUuid
                                    }, null, 8, ["package", "priceBundleUuid"]),
                                    _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("div", _hoisted_22, [
                                            _cache[22] || (_cache[22] = _createElementVNode("h3", { class: "fw-bold bg-primary text-white mb-4 px-3 py-2" }, "Preis-Aufschlag", -1)),
                                            _createVNode(ProductPriceAddition, {
                                                package: props.package
                                            }, null, 8, ["package"])
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                                _createVNode(ProductImages, {
                                    package: props.package
                                }, null, 8, ["package"])
                            ])
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
